import Vue from 'vue';

import './bootstrap.js';

import App from './App.vue';
import router from './router';
import store from './store/index.js';
import StorageControl from './store/storageControl.js';
import { EventBus } from 'relapp-event';
import './registerServiceWorker';
import './styles/main.scss';
import Tracking from './services/tracking.js';

window.gtmTracker = new Tracking(window);
// whether we skip loading google tag manager if the browser is set not to track is now determined by us.
if (process.env.VUE_APP_GTM_ID && !navigator.doNotTrack) {
    window.gtmTracker.loadGoogleTagManager(process.env.VUE_APP_GTM_ID);
}

let app;

router.beforeEach((to, from, next) => {
    EventBus.$emit('clearNotification');
    next();
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters['user/isLoggedIn']) {
            next();

            return;
        }
        next('/');
    } else {
        next();
    }
});

Vue.config.productionTip = false;

/**
 * Initialize Vue.
 */
app = new Vue({
    router,
    store,
    data: {
        version: 1.0
    },
    render: h => h(App)
}).$mount('#app');

StorageControl.check(app.version);
